/**
 * Card Discount Display — 15% / 40% override
 *
 * Re-applies the promotional sale display on product cards after theme.js's
 * swatch handler overwrites the price markup. Supports two rules, evaluated
 * in priority order by price.liquid:
 *   1. Products tagged `saleaug26`            → 40% off display
 *   2. Products in `exclude-prods-discount`   → 15% off display
 *
 * The .price element carries data-discount-collection="<percent>" (set by
 * price.liquid) for eligible products. This script reads that percent and
 * re-applies the crossed-out original price + calculated discounted price
 * after any swatch click or the auto-triggered swatch click on page load.
 */
(function () {
    'use strict';

    function applyDiscountPrice(productItem) {
        var priceEl = productItem.querySelector('.price[data-discount-collection]');
        if (!priceEl) return;

        var percent = Number(priceEl.getAttribute('data-discount-collection'));
        if (!percent) return;

        var json = productItem.getAttribute('data-json-product');
        if (!json) return;

        var data;
        try { data = JSON.parse(json); } catch (e) { return; }

        var activeSwatch = productItem.querySelector('.swatch-label.is-active');
        var variantId = activeSwatch ? activeSwatch.getAttribute('data-variant-id') : null;

        var selectedVariant = null;
        if (variantId) {
            for (var i = 0; i < data.variants.length; i++) {
                if (String(data.variants[i].id) === String(variantId)) {
                    selectedVariant = data.variants[i];
                    break;
                }
            }
        }
        if (!selectedVariant) {
            selectedVariant = data.variants[0];
        }
        if (!selectedVariant) return;

        var originalPrice = selectedVariant.price;
        var discountedPrice = Math.round(originalPrice * (1 - percent / 100));

        priceEl.classList.add('price--on-sale');

        var regularEl = priceEl.querySelector('.price__sale .price-item--regular');
        var saleEl = priceEl.querySelector('.price__sale .price-item--sale');
        var labelEl = priceEl.querySelector('.price__label_sale .label_sale');

        if (regularEl) regularEl.innerHTML = Shopify.formatMoney(originalPrice, window.money_format);
        if (saleEl) saleEl.innerHTML = Shopify.formatMoney(discountedPrice, window.money_format);
        if (labelEl) labelEl.innerHTML = '(-' + percent + '%)';
    }

    function applyAll() {
        var items = document.querySelectorAll('.product-item');
        for (var i = 0; i < items.length; i++) {
            applyDiscountPrice(items[i]);
        }
    }

    // Re-apply after every swatch click (delegated, fires after theme.js handler)
    document.addEventListener('click', function (event) {
        var target = event.target.closest ? event.target.closest('.card .swatch-label') : null;
        if (!target) return;
        var productItem = target.closest('.product-item');
        if (!productItem) return;
        // Defer to next tick so theme.js's handler runs first
        setTimeout(function () { applyDiscountPrice(productItem); }, 0);
    }, true);

    // Re-apply on initial load (after theme.js auto-triggers active swatch)
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            setTimeout(applyAll, 0);
        });
    } else {
        setTimeout(applyAll, 0);
    }

    // Re-apply after AJAX section renders (collection filters, load-more, etc.)
    document.addEventListener('DOMContentLoaded', function () {
        // Watch for new product items being injected
        if (typeof MutationObserver !== 'undefined') {
            var observer = new MutationObserver(function (mutations) {
                for (var i = 0; i < mutations.length; i++) {
                    var nodes = mutations[i].addedNodes;
                    for (var j = 0; j < nodes.length; j++) {
                        if (nodes[j].querySelector && nodes[j].querySelector('.product-item .price[data-discount-collection]')) {
                            setTimeout(applyAll, 0);
                            return;
                        }
                    }
                }
            });
            observer.observe(document.body, { childList: true, subtree: true });
        }
    });
})();

/**
 * Mobile Menu — SALE badge injector
 *
 * Handles two HTML structures found in halo-navigation-mobile.liquid:
 *   Structure A: .menu-lv-1__action > span.text  (most items)
 *   Structure B: .menu-lv-1__action > p > a.text (Hijabs & Accessories type)
 */
(function () {
    'use strict';

    var SALE_ITEMS = [
        'abayas',
        'everyday essentials',
        'umrah & prayer',
        'modest co-ords',
        'occasion wear',
        'kids abayas',
        'hijabs & accessories',
        'active wear',
        '40% off'
    ];

    var BADGE_STYLE = 'display:inline-block;margin-left:8px;background:#3a9e3a;color:#fff;font-size:10px;font-weight:700;letter-spacing:0.08em;padding:2px 7px;border-radius:2px;vertical-align:middle;line-height:1.6;text-transform:uppercase;';

    function injectSaleBadges() {

        // Structure A: standard items with span.text inside .menu-lv-1__action
        var menuLinks = document.querySelectorAll('.menu-lv-1__action');
        menuLinks.forEach(function (link) {
            if (link.querySelector('.mobile-sale-badge')) return;
            var textEl = link.querySelector('span.text');
            if (!textEl) return;
            var text = textEl.textContent.trim().toLowerCase();
            if (SALE_ITEMS.indexOf(text) !== -1) {
                var badge = document.createElement('span');
                badge.className = 'mobile-sale-badge';
                badge.style.cssText = BADGE_STYLE;
                badge.textContent = 'SALE';
                textEl.parentNode.insertBefore(badge, textEl.nextSibling);
            }
        });

        // Structure B: items where .text class is on the <a> tag itself (e.g. Hijabs & Accessories)
        var textLinks = document.querySelectorAll('.menu-lv-1__action a.text');
        textLinks.forEach(function (aTag) {
            if (aTag.querySelector('.mobile-sale-badge')) return;
            // Get only the direct text content, ignore child elements
            var text = '';
            aTag.childNodes.forEach(function (node) {
                if (node.nodeType === 3) { // text node only
                    text += node.textContent;
                }
            });
            text = text.trim().toLowerCase();
            if (SALE_ITEMS.indexOf(text) !== -1) {
                var badge = document.createElement('span');
                badge.className = 'mobile-sale-badge';
                badge.style.cssText = BADGE_STYLE;
                badge.textContent = 'SALE';
                aTag.appendChild(badge);
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', injectSaleBadges);
    } else {
        injectSaleBadges();
    }

    // Re-run when mobile menu drawer opens
    if (typeof MutationObserver !== 'undefined') {
        var observer = new MutationObserver(function () {
            injectSaleBadges();
        });
        document.addEventListener('DOMContentLoaded', function () {
            observer.observe(document.body, { childList: true, subtree: true });
        });
    }

})();